import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { Comercializacion, ComercializacionBackend } from './comercializaciones.model';

@Injectable({
  providedIn: 'root'
})
export class ComercializacionesService {
  url: string;
  endpoint = 'comercializaciones';

  constructor(private http: HttpClient) {}

  getComercializaciones(): Observable<Comercializacion[]> {
    return this.http.get<Comercializacion[]>(`${this.url}/${this.endpoint}/`);
  }

  addComercializaciones(comercializaciones: Comercializacion[]): Observable<ComercializacionBackend> {
    return this.http.post<ComercializacionBackend>(`${this.url}/${this.endpoint}/`, {
      comercializaciones
    });
  }
}
